import { render, staticRenderFns } from "./emptyMenu.vue?vue&type=template&id=726b472c"
import script from "./emptyMenu.vue?vue&type=script&lang=js"
export * from "./emptyMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports